import React from "react";
import { useDispatch } from "react-redux";
import { deleteUser } from "../../../../REDUX/actions/user";
import Button from "../../../Common/FormElements/Button/Button";
import { closeCenteredModal } from "../../../../REDUX/actions/centeredModal";
import DeleteBtn from "../../../Common/FormElements/DeleteBtn";
import { useTranslation } from "react-i18next";
const DeleteMember = ({ id, userRole }) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const handleDelete = () => {
    dispatch(deleteUser(id, userRole, t));
    dispatch(closeCenteredModal());
  };
  return (
    <div className="d-flex align-items-center flex-column gap-2">
      <p>
        {t("Are you sure you want to delete")}{" "}
        {userRole === 1 ? t("this admin") : t("this reseller")} ?
      </p>
      <div className="d-flex gap-3">
        <DeleteBtn onClick={handleDelete} />
        <Button onClick={() => dispatch(closeCenteredModal())}>
          {t("Cancel")}
        </Button>
      </div>
    </div>
  );
};

export default DeleteMember;
